<template>
	<div id="app">
		<transition name="fade" mode="in-out">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: "App"
};
</script>

<style lang="scss">
body {
	font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
}

.fade-enter {
	opacity: 0;
}

.fade-leave {
	opacity: 1;
}

.fade-enter-active {
	transition: opacity 0.5s;
}

.fade-leave-active {
	opacity: 0;
	transition: opacity 0.5s;
}

.pswp {
	z-index: 3000 !important;
}

.emoji-mart-scroll {
	background-color: #fff !important;
}
</style>
